(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schematic-page"]) return;
  try {
    
if (!customElements.get('schematic-page-app')) {
  customElements.define('schematic-page-app', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.addEventListener('hashchange', this.onHash); return; }
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-schematic-data]').textContent);
      const uiBlock = this.querySelector('[data-schematic-ui]');
      this.ui = uiBlock ? JSON.parse(uiBlock.textContent) : {};
      this.family = this.dataset.family;
      this.familyModels = Object.keys(this.data.models).filter(k => this.data.models[k].family === this.family);
      this.model = this.familyModels[0];
      this.select = this.querySelector('[data-model]');
      this.search = this.querySelector('[data-search]');
      // Search hint from this machine's own parts list (the stock hint is a SEBO part number).
      const rows = this.familyModels.flatMap(k => Object.values(this.data.models[k].assemblies || {}).flat());
      const sample = rows.find(r => r.url && r.sku && /^[A-Za-z0-9.\-]{3,14}$/.test(r.sku));
      if (sample && this.search) {
        const words = ['filter', 'brush', 'belt', 'hose', 'bag', 'wheel', 'switch', 'motor', 'squeegee', 'cord'];
        const text = rows.map(r => (r.description || '').toLowerCase()).join(' ');
        const word = words.find(w => text.includes(w));
        this.search.placeholder = 'Try ' + sample.sku + (word ? ' or ' + word : '');
      }
      this.familyModels.forEach(k => {
        const option = document.createElement('option');
        option.value = k;
        option.textContent = (this.data.model_labels || {})[k] || k;
        this.select.append(option);
      });
      // One model: nothing to choose, so show its label (machine and SKU) as text instead of
      // a one-option dropdown. The label stays, because it is how a customer confirms the page.
      const single = this.familyModels.length < 2;
      this.select.hidden = single;
      const fixed = this.querySelector('[data-model-fixed]');
      if (fixed) {
        fixed.hidden = !single;
        fixed.textContent = single ? ((this.data.model_labels || {})[this.model] || this.model) : '';
      }
      this.applyHash();
      this.assembly = this.assemblyKeys(this.model)[0];
      this.onHash = () => { this.applyHash(); this.search.value = ''; this.render(); };
      window.addEventListener('hashchange', this.onHash);
      this.select.addEventListener('change', () => {
        this.model = this.select.value;
        const url = new URL(location.href);
        url.hash = new URLSearchParams({model:this.model}).toString();
        history.replaceState(null, '', url);
        this.search.value = '';
        this.zoom();
        this.render();
      });
      this.search.addEventListener('input', () => this.renderRows());
      this.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => this.zoom(button)));
      this.render();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); }
    zoom(button) {
      const buttons = [...this.querySelectorAll('[data-zoom]')];
      button = button || buttons[0];
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const canvas = this.querySelector('[data-canvas]');
      const factor = Number(button.dataset.zoom);
      // "Fit" clears the inline size so the stylesheet applies again; leaving max-width:none
      // behind is what let a zoomed-then-fitted drawing overflow on phones.
      canvas.style.width = factor === 1 ? '' : factor * 100 + '%';
      canvas.style.maxWidth = factor === 1 ? '' : 'none';
    }
    assemblyKeys(model) {
      const keys = Object.keys(this.data.models[model].assemblies);
      const rank = k => k === 'et1' ? 2 : (k === 'head' ? 1 : 0);
      return keys.sort((a, b) => rank(a) - rank(b));
    }
    applyHash() {
      const requested = new URLSearchParams(location.hash.slice(1)).get('model');
      if (this.data.models[requested]?.family === this.family) this.model = requested;
      else {
        const sku = new URLSearchParams(location.hash.slice(1)).get('sku');
        const matched = this.familyModels.find(k => (this.data.models[k].machine_skus || []).includes(sku));
        if (matched) this.model = matched;
      }
      this.select.value = this.model;
    }
    url(path) {
      const url = new URL(path, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    renderAssemblies() {
      const keys = this.assemblyKeys(this.model);
      if (!keys.includes(this.assembly)) this.assembly = keys[0];
      const group = this.querySelector('[data-assemblies]');
      group.replaceChildren();
      group.hidden = keys.length < 2;
      keys.forEach(k => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.assembly = k;
        button.textContent = (this.data.assembly_labels || {})[k] || k;
        button.setAttribute('aria-pressed', String(k === this.assembly));
        button.addEventListener('click', () => {
          this.assembly = k;
          this.search.value = '';
          this.zoom();
          this.render();
          this.querySelector('.schematic-viewport').scrollTo(0,0);
          // render() rebuilds these buttons; put focus back on the one just pressed so a
          // keyboard user is not dropped to the top of the page.
          const again = this.querySelector('[data-assembly="' + k + '"]');
          if (again) again.focus();
        });
        group.append(button);
      });
    }
    refsOf(label) {
      // Which drawing callouts a parts-table reference binds to. Single-brand data uses a
      // bare number; Miele's MSD uses its "Pos." label, which can be "80+90" (one part at
      // two callouts), "110-130" (an assembly-level part spanning a range, which Miele
      // itself does not bind to any one callout) or "w/o fig." (not on the drawing).
      const s = String(label == null ? '' : label).trim();
      if (!s || s === 'w/o fig.' || /^\d+\s*-\s*\d+\+?$/.test(s)) return [];
      if (/^\d+(\s*\+\s*\d+)*\+?$/.test(s)) return s.split('+').map(t => t.trim()).filter(Boolean);
      return [s];
    }
    rowsForRef(ref) {
      return this.data.multi_ref === true
        ? this.rows.filter(r => this.refsOf(r.ref).indexOf(ref) !== -1)
        : this.rows.filter(r => r.ref === ref);
    }
    showRef(ref) {
      this.refFilter = ref;
      this.search.value = '';
      this.renderRows();
      const scroll = this.querySelector('.schematic-table-scroll');
      if (scroll) scroll.scrollTop = 0;
      const first = this.querySelector('[data-rows] tr');
      if (first) first.focus({preventScroll:true});
    }
    render() {
      this.refFilter = null;
      // Miele-style "Pos." labels ("110-130", "w/o fig.") need a wider first column than
      // the 48px a bare callout number needs. Scoped so other brands are untouched.
      const multi = this.data.multi_ref === true;
      this.classList.toggle('is-multiref', multi);
      this.renderAssemblies();
      const modelData = this.data.models[this.model];
      this.rows = modelData.assemblies[this.assembly];
      const diagram = this.data.diagrams[modelData.diagrams[this.assembly]];
      const label = (this.data.assembly_labels || {})[this.assembly] || this.assembly;
      this.querySelector('[data-assembly-title]').textContent = label;
      const card = this.querySelector('.schematic-diagram-card');
      const workspace = this.querySelector('.schematic-workspace');
      if (!diagram.url) {
        // A machine can have a verified parts list before usable artwork exists. Miele's
        // portal only serves a 347x463 raster, far too coarse to place callouts on, so the
        // table renders alone rather than showing a broken image and dead hotspots.
        if (card) card.hidden = true;
        if (workspace) workspace.classList.add('is-tableonly');
        this.renderRows();
        return;
      }
      if (card) card.hidden = false;
      if (workspace) workspace.classList.remove('is-tableonly');
      const img = this.querySelector('[data-diagram]');
      img.src = diagram.url;
      img.alt = ((this.data.model_labels || {})[this.model] || this.model) + ' — ' + label + ' ' + (this.ui.diagram_alt || 'exploded parts diagram');
      img.width = diagram.width;
      img.height = diagram.height;
      const hint = this.querySelector('[data-hint]');
      if (hint) hint.textContent = diagram.hotspots.length ? this.ui.hint_hotspots : this.ui.hint_printed;
      const layer = this.querySelector('[data-hotspots]');
      layer.replaceChildren();
      diagram.hotspots.forEach(h => {
        const matches = this.rowsForRef(h.ref);
        // One callout can carry several CURRENT parts -- Miele offers alternative fitments
        // (Act.AirClean / HEPA / AirClean Plus all sit on one number) and colour variants.
        // Linking straight to the first of those picks a part on the customer's behalf, so
        // `multi_ref` data filters the table to the callout instead. Single-match callouts,
        // and every dataset without the flag, behave exactly as before.
        // No row for this callout (e.g. the part sits in another assembly): keep the number on
        // the drawing, grey, and say so in the table, instead of silently dropping it.
        const row = matches[0];
        const many = multi && matches.length > 1;
        const link = document.createElement('a');
        link.className = 'schematic-hotspot' + (row && row.url && !many ? '' : ' is-unlisted');
        // The box is sized to the printed number on the drawing; the label inside scales to fit it
        // (container units, so it follows zoom and screen width) and stays centered.
        const text = document.createElement('span');
        text.textContent = h.label;
        link.style.setProperty('--n', Math.max(String(h.label).length, 1));
        link.append(text);
        // Number printed inside a ring (most brand drawings): the chip covers the ring, as an oval.
        const box = h.ring || [h.x, h.y, h.w, h.h];
        link.style.left = box[0] + '%';
        link.style.top = box[1] + '%';
        link.style.width = box[2] + '%';
        link.style.height = box[3] + '%';
        if (h.ring) link.style.borderRadius = '50%';
        link.title = !matches.length
          ? 'Ref. ' + h.label + ' — ' + this.ui.ref_elsewhere
          : many
            ? 'Ref. ' + h.label + ' · ' + matches.length + ' ' + this.ui.count_choose
            : 'Ref. ' + h.label + ' · ' + (row.sku || '—') + ' · ' + row.description;
        link.setAttribute('aria-label', link.title);
        const jump = !matches.length || many || !row.url;
        link.href = jump ? '#schematic-row-' + this.assembly + '-' + h.ref : this.url(row.url);
        if (jump) link.addEventListener('click', event => {
          event.preventDefault();
          // Filter the table only when several parts share this callout. A single part (stocked
          // or not) or a number listed elsewhere keeps the full list and scrolls to its row, so
          // the rest of the list stays visible.
          if (many) return this.showRef(h.ref);
          this.refFilter = null;
          this.search.value = '';
          this.renderRows();
          const target = this.querySelector('[id="schematic-row-' + this.assembly + '-' + h.ref + '"]');
          if (!target) return;
          target.scrollIntoView({block:'center',behavior:'smooth'});
          target.focus({preventScroll:true});
        });
        layer.append(link);
      });
      this.renderRows();
    }
    renderRows() {
      const query = this.search.value.trim().toLowerCase();
      if (query) this.refFilter = null;
      const pool = this.refFilter ? this.rowsForRef(this.refFilter) : this.rows;
      const visible = pool.filter(row => [row.ref,row.sku,row.description].join(' ').toLowerCase().includes(query));
      const body = this.querySelector('[data-rows]');
      body.replaceChildren();
      const used = {};
      visible.forEach(row => {
        const tr = document.createElement('tr');
        // Several parts can share one reference, so the first keeps the anchor the
        // hotspots and deep links point at and later ones get a suffix. Without this the
        // page emits duplicate ids and the browser can only ever reach the first.
        const base = 'schematic-row-' + this.assembly + '-' + row.ref;
        used[base] = (used[base] || 0) + 1;
        tr.id = used[base] === 1 ? base : base + '-' + used[base];
        tr.tabIndex = -1;
        const ref = document.createElement('td');
        ref.textContent = row.ref;
        const sku = document.createElement('td');
        const number = document.createElement(row.url ? 'a' : 'span');
        // Several part numbers in one cell (Oreck lists black + red): wrap between them, never inside one.
        const skus = String(row.sku || '—').trim().split(/\s+/);
        if (skus.length > 1) {
          sku.style.whiteSpace = 'normal';
          skus.forEach((s, i) => { const part = document.createElement('span'); part.style.whiteSpace = 'nowrap'; part.textContent = s; number.append(part, i < skus.length - 1 ? ' ' : ''); });
        } else number.textContent = skus[0];
        if (row.url) number.href = this.url(row.url);
        sku.append(number);
        const description = document.createElement('td');
        description.textContent = row.description;
        if (!row.url) {
          const note = document.createElement('span');
          note.className = 'schematic-unlisted';
          note.textContent = this.data.unlisted_note || this.ui.unlisted_default;
          description.append(note);
        }
        tr.append(ref,sku,description);
        body.append(tr);
      });
      this.querySelector('[data-count]').textContent = this.refFilter
        ? (visible.length
            ? 'Ref. ' + this.refFilter + ' — ' + visible.length + ' ' + (visible.length === 1 ? this.ui.count_one : this.ui.count_choose)
            : 'Ref. ' + this.refFilter + ' ' + this.ui.ref_not_listed)
        : visible.length + ' ' + this.ui.count_shown;
      this.querySelector('[data-empty]').hidden = visible.length > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
